import axios from 'axios';
import {getCookie} from '@insticator/insticator-ui'; // iui-utils
import {url} from '../../../utils/urls';

const withCredentials = true;
const headers = {
  "Content-Type": "application/json",
  'Accept': 'application/json',
  'Authorization': `Bearer ${getCookie('pub_portal_user')}`
};

export const fetchSitesWithV2Products = (accountId) => axios.get(`${url.ppa.accounts}/${accountId}/commentingv2/sites`, { headers, withCredentials });

export const getMigrationStatus = siteId => axios.get(`${url.ccb.url}/v1/sites/${siteId}/migration-status`, { headers, withCredentials });

export const updateMigrationStatus = (siteId, data) => axios.put(`${url.ccb.url}/v1/sites/${siteId}/migration?currentStatus=${data.currentStatus}&adminEmail=${data.adminEmail}`, data, { headers, withCredentials });
